import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';

/**
 * "Your Contact Information" section of the BookingModal (extracted to keep the
 * modal focused). Purely presentational; state stays in the parent.
 */
export const BookingContactInfo = ({ customerPhone, setCustomerPhone, customerEmail, setCustomerEmail }) => (
  <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-lg space-y-4 border border-gray-200 dark:border-gray-600">
    <h3 className="font-semibold text-base text-gray-800 dark:text-gray-100 mb-3">Your Contact Information</h3>

    {/* Phone Number */}
    <div>
      <Label htmlFor="customerPhone" className="text-sm font-medium mb-1 block text-gray-700 dark:text-gray-300">
        Phone Number
      </Label>
      <Input
        id="customerPhone"
        type="tel"
        value={customerPhone}
        onChange={(e) => setCustomerPhone(e.target.value)}
        placeholder="16478247355"
        className="w-full"
      />
    </div>

    {/* Email Address */}
    <div>
      <Label htmlFor="customerEmail" className="text-sm font-medium mb-1 block text-gray-700 dark:text-gray-300">
        Email Address
      </Label>
      <Input
        id="customerEmail"
        type="email"
        value={customerEmail}
        onChange={(e) => setCustomerEmail(e.target.value)}
        placeholder="your.email@example.com"
        className="w-full"
        required
      />
    </div>
  </div>
);
